import { createFileRoute } from "@tanstack/react-router";
import { ContentLayout } from "@/content-site/components/layout";
import { getContentTree } from "@/content-site/lib/loaders";
export const Route = createFileRoute("/_content/docs")({
  staleTime: 5 * 60_000,
  preloadStaleTime: 5 * 60_000,
  loader: () => getContentTree(),
  component: Page,
});
function Page() {
  return <ContentLayout data={Route.useLoaderData()} />;
}
